module.exports = __webpack_public_path__ + "static/reese-witherspoon-9a649c8746cfac3ae1ab793d894772f6.jpg";